export const addThreeHours = (date: Date) => {
  const dateCopy = new Date(date.getTime());
  dateCopy.setHours(dateCopy.getHours() + 3);
  return dateCopy;
};
